import type { Script } from '../models/script.ts'
import { patchSession } from '@/features/session/domain/use-cases/patch-session.ts'
import { useScriptStore } from '@/shared/store/script.store.ts'
import type { Result } from '@siroc/types'

export const updateScript = (id: string, text: string): Result<Script> => {
  const scriptStore = useScriptStore.getState()
  const newScript: Script = {
    id,
    text,
    lastUpdate: new Date(),
  }

  scriptStore.updateScript(newScript)
  void patchSession()
  return { ok: true, data: newScript }
}
